#import "../fragments/URLFragment.gql"
fragment StudioFragment on Studio {
  id
  name
  aliases
  parent {
    id
    name
  }
  urls {
    ...URLFragment
  }
  images {
    id
    url
    height
    width
  }
  deleted
  is_favorite
}
